
import React from 'react';

import ParameterListBase from './ParameterListBase';
import getParameterDefinitions from './getParameterDefinitions';

const ParameterList = ({
    params,
    paramValues,
    onConfirm,
    onChangeValue
}) => {

    return (
        <ParameterListBase
            paramDefinitions={getParameterDefinitions()}
            params={params}
            paramValues={paramValues}
            onConfirm={onConfirm}
            onChangeValue={onChangeValue}
        />
    );
}

export default ParameterList;
